import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Body } from 'syf-component-library/ui/typography';
import { faSnowflake } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from '../../../translations/getTranslation';
import globalTheme from '../../../theme';
const CardContainer = styled.div `
  border-radius: 8px;
  margin: ${({ theme: { spacing } }) => `${spacing.base}px auto ${spacing.base}px auto;`};
  padding: ${({ theme: { spacing } }) => `${spacing.large}px ${spacing.base}px`};
  background-color: ${({ theme }) => theme.colors.turquoiseLightest};
`;
const CardHeading = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small}px;
`;
const CardBody = styled.div `
  margin-left: 30px;
`;
const Title = styled(Body) `
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.denimBlue};
`;
const Paragraph = styled(Body) `
  font-size: ${({ theme }) => theme.fontSizes.regular}px;
`;
const FreezeCard = () => {
    return (_jsxs(CardContainer, { children: [_jsxs(CardHeading, { children: [_jsx(FontAwesomeIcon, { icon: faSnowflake, size: "lg", color: globalTheme.colors.denimBlue, title: "Freeze Icon" }), _jsx(Title, { children: t('reasonSelectionLostStolen.freezeAccount') })] }), _jsx(CardBody, { children: _jsx(Paragraph, { children: t('reasonSelectionLostStolen.needTime') }) })] }));
};
export default FreezeCard;
//# sourceMappingURL=index.js.map